import { useIntl } from "react-intl";
import { Field } from "react-final-form";
import countries from "../../../../assets/data/countries";
import Section from "../../../common/section";
import * as Validations from "../../../common/form/validator";
import { DropdownInput, TextInput } from "../../../common/fields";

const EnterpriseDetailsForm = ({ disabled = false, record }) => {
  const intl = useIntl();
  return (
    <div className="grid gap-3">
      <Section title="enterprise_details" className="col-12">
        <div className="grid">
          {(disabled && record && (
            <div className="col-12">
              <img
                src={`${new URL(
                  record?.logo,
                  process.env.REACT_APP_URL
                ).toString()}`}
                alt={record?.name}
                className="edexlms-enterprise-list-logo"
              />
            </div>
          )) ||
            null}
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="name"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "name",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "name",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="industry"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "industry",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "industry",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="address1"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "address_1",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "address_1",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="address2"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "address_2",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "address_2",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="country"
              component={DropdownInput}
              type="text"
              label={intl.formatMessage({
                id: "country",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "country",
              })}
              filter
              options={countries.map((country) => ({
                value: country.country,
                name: country.country,
              }))}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
        </div>
      </Section>
      <Section title="contact_info" className="col-12">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="contactName"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "contact_person",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "contact_person",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="contactEmail"
              component={TextInput}
              type="email"
              icon="pi-envelope"
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "contact_email",
              })}
              label={intl.formatMessage({
                id: "contact_email",
              })}
              required
              validate={Validations.composeValidators(
                Validations.required,
                Validations.checkEmailFormat
              )}
            />
          </div>
        </div>
      </Section>
      <Section title="entitlements" className="col-12">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="entitlements[0].value"
              component={TextInput}
              type="number"
              placeholder={intl.formatMessage({
                id: "no_of_users",
              })}
              disabled={disabled}
              label={intl.formatMessage({
                id: "no_of_users",
              })}
              maxLength={10}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="entitlements[1].value"
              component={TextInput}
              type="number"
              placeholder={intl.formatMessage({
                id: "storage",
              })}
              disabled={disabled}
              label={intl.formatMessage({
                id: "storage",
              })}
              maxLength={10}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
        </div>
      </Section>
    </div>
  );
};

export default EnterpriseDetailsForm;
